import React, { useState, useEffect } from "react";
import Container from "../../../components/layout/Container/Container";
import Header from "../../../components/molecules/Header/Header";
import { getInspections } from "../../../api/apimethods";
import { IInspectionResponseModel } from "../../../typings/models/InspectionResponseModel";
import ISRInspectionGrid from "./ISRInspectionGrid";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useAuthService, useContextService } from "../../../services";

const ISRInspectionDashboard: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const [data, setData] = useState<IInspectionResponseModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        var userId = user.idNo;
        if (user.role === "CorpPass") userId = user.uen;
        const response = await getInspections("ISR", userId);
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div>
        <h1>t</h1>
        <ISRInspectionGrid data={data} isLoading={isLoading} />
      </div>
    </>
  );
};

export default ISRInspectionDashboard;
